'use client';

import { hexTintOnWhite } from '@repo/design-system/utils/color';
import type { GroupedCategory } from '@repo/types/maps/map-types';

const TINT_AMOUNT = 0.15;
export const DOT_SCALE = 1.33;

/**
 * Derives the per-pill tint styles for the category matching the currently
 * selected map pin. Returns a lookup keyed by category externalId so the
 * render loop can apply the styles declaratively.
 */
export function getPinSelectTintStyles(
    selectedPinCategoryId: string | null,
    activeCategoryId: string | null,
    allCategories: GroupedCategory[],
): { backgroundColor?: string; dotScale?: number } | null {
    if (!selectedPinCategoryId || activeCategoryId) return null;
    const category = allCategories.find(c => c.externalId === selectedPinCategoryId);
    if (!category) return null;
    return {
        backgroundColor: hexTintOnWhite(category.original.color, TINT_AMOUNT),
        dotScale: DOT_SCALE,
    };
}
